import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import ZoeaLogo from '@/components/ZoeaLogo';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Vul je e-mailadres in');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Er ging iets mis, probeer het later opnieuw');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-teal-50/30 flex flex-col justify-center px-4 sm:px-6">
      <div className="w-full max-w-sm mx-auto">
        <Link to="/login" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          <span>Terug naar inloggen</span>
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <ZoeaLogo className="h-12" />
        </div>

        {sent ? (
          <>
            <h1 className="text-2xl font-bold text-slate-900 mb-2 font-['Manrope']">Check je e-mail</h1>
            <p className="text-slate-600">
              Als <strong>{email}</strong> bij ons bekend is, ontvang je binnen enkele minuten een e-mail met een link om je wachtwoord te resetten.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-slate-900 mb-2 font-['Manrope']">Wachtwoord vergeten?</h1>
            <p className="text-slate-600 mb-8">Vul je e-mailadres in en we sturen je een resetlink.</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="email">E-mailadres</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="naam@voorbeeld.nl"
                  className="h-12 rounded-xl border-slate-200 focus:border-teal-500 focus:ring-teal-500/20"
                />
              </div>

              <Button
                type="submit"
                disabled={submitting}
                className="w-full h-12 bg-teal-600 hover:bg-teal-700 text-white rounded-xl font-medium"
              >
                {submitting ? 'Bezig...' : 'Stuur resetlink'}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
